import prepareComponent from "@bluframe/grapple/prepareComponent"
import useTrimText from "@bluframe/grapple/useTrimText"
import React from "react"
import remarkGfm from "remark-gfm"
import strip from "strip-markdown"

import Content from "./Content"

// Find a better solution other than any
export interface ContentComponents {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [tag: string]: (props: any) => any
}

export interface Props {
  className?: string
  components?: ContentComponents
  content: string
  max?: number
  paragraphAs?: string
  remarkPlugins?: boolean
  stripMarkdown?: boolean
  wrapperAs?: React.ElementType
}

export interface ComponentProps extends Omit<
  Props,
  "max" | "paragraphAs" | "remarkPlugins" | "stripMarkdown"
> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rehypePlugins: any[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  remarkPlugins: any[]
}

const getParagraphComponents = (paragraphAs?: string): ContentComponents => {
  if (!paragraphAs) {
    return {}
  }

  return {
    // eslint-disable-next-line id-length
    p: ({ node, ...props }) => React.createElement(paragraphAs, props)
  }
}

const getRemarkPlugins = (
  withRemarkPlugins?: boolean,
  stripMarkdown?: boolean
): ComponentProps["remarkPlugins"] => {
  const remarkPlugins: ComponentProps["remarkPlugins"] = []

  if (withRemarkPlugins) {
    remarkPlugins.push(remarkGfm)
  }

  if (stripMarkdown) {
    remarkPlugins.push(strip)
  }

  return remarkPlugins
}

const usePrepareComponent = ({
  className,
  components: overrideComponents = {},
  content,
  max = Infinity,
  paragraphAs,
  remarkPlugins: withRemarkPlugins,
  stripMarkdown,
  wrapperAs
}: Props): ComponentProps => {
  const trimmedContent = useTrimText(content, max)

  return {
    className,
    components: {
      ...getParagraphComponents(paragraphAs),
      ...overrideComponents
    },
    content: trimmedContent,
    rehypePlugins: [],
    remarkPlugins: getRemarkPlugins(withRemarkPlugins, stripMarkdown),
    wrapperAs
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Content
)
